export const FormaAtendimento = {
  Presencial: 1,
  Videoconferencia: 2,
  Telefone: 3
}
